import Cookies from 'js-cookie';

export const xapDismissed = () => Cookies.get('xap') === '1';

export const setXapDismissed = (v) => {
  Cookies.set('xap', v ? 1 : 0, { domain: '.xfinity.com', path: '/' });
};
